import { render, staticRenderFns } from "./ThumbnailCard.vue?vue&type=template&id=572eb02f&scoped=true"
import script from "./ThumbnailCard.vue?vue&type=script&lang=js"
export * from "./ThumbnailCard.vue?vue&type=script&lang=js"
import style0 from "./ThumbnailCard.vue?vue&type=style&index=0&id=572eb02f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572eb02f",
  null
  
)

export default component.exports